import React from "react";
import { Star } from "lucide-react";
import { Reveal, SectionTitle } from "./Bits";

const METRICS = [
  { v: "10.000+", l: "orçamentos gerados" },
  { v: "11s", l: "tempo médio por orçamento" },
  { v: "4,9/5", l: "avaliação média" },
  { v: "30+", l: "nichos atendidos" },
];

const TESTIMONIALS = [
  { name: "Ricardo Silva", role: "Engenheiro · Obras", initials: "RS", color: "#b45309", quote: "Mandava orçamento em bloco de notas. Hoje faço no WhatsApp em 10 segundos, direto da obra, e fecho mais contrato." },
  { name: "Beatriz Mendes", role: "Designer de Interiores", initials: "BM", color: "#4A3BFA", quote: "Tenho duas marcas e alterno entre elas por mensagem. O PDF chega com a identidade certa, sem eu abrir o computador." },
  { name: "Lucas Alencar", role: "Dev Fullstack", initials: "LA", color: "#059669", quote: "Orçamento profissional em segundos, com acabamento impecável. O cliente sente o cuidado antes mesmo de fechar." },
];

export default function SocialProofBlock() {
  return (
    <section className="mt-24" data-testid="upgrade-social">
      <Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {METRICS.map((m) => (
            <div key={m.l} className="text-center rounded-2xl bg-white ring-1 ring-slate-200 py-6 px-3">
              <div className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{m.v}</div>
              <div className="text-[12.5px] text-slate-500 mt-1">{m.l}</div>
            </div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.05} className="mt-14">
        <SectionTitle eyebrow="Quem já usa" title="Profissionais que pararam de perder tempo com formatação." />
      </Reveal>
      <div className="mt-8 grid md:grid-cols-3 gap-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.05 * i}>
            <figure className="h-full rounded-3xl bg-white ring-1 ring-slate-200 p-6 flex flex-col">
              <div className="flex items-center gap-0.5 text-amber-400">{[0, 1, 2, 3, 4].map((k) => <Star key={k} size={14} fill="currentColor" />)}</div>
              <blockquote className="mt-4 text-[14px] text-slate-700 leading-relaxed flex-1">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="grid place-items-center w-10 h-10 rounded-full text-white text-[12px] font-bold" style={{ background: t.color }}>{t.initials}</span>
                <div>
                  <div className="text-[13px] font-semibold text-slate-900">{t.name}</div>
                  <div className="text-[12px] text-slate-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
